var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "container container-small" },
      [
        _vm.device == "desktop"
          ? [
              _vm.showInfo
                ? _c("div", { staticClass: "pt-3 import-info" }, [
                    _vm._m(0),
                    _vm._m(1),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "action-button" }, [
                _c(
                  "button",
                  {
                    staticClass: "mt-3 d-block main-btn w-100",
                    on: {
                      click: function ($event) {
                        _vm.showInfo = !_vm.showInfo
                      },
                    },
                  },
                  [
                    _vm.showInfo
                      ? _c("span", { staticClass: "fas fa-long-arrow-alt-up" })
                      : _vm._e(),
                    !_vm.showInfo
                      ? _c("span", {
                          staticClass: "fas fa-long-arrow-alt-down",
                        })
                      : _vm._e(),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.showInfo
                            ? _vm.$t("btn_show_less_info")
                            : _vm.$t("btn_show_more_info")
                        ) +
                        " "
                    ),
                  ]
                ),
              ]),
              _vm.imported
                ? _c(
                    "div",
                    {
                      staticClass: "text-center mt-3",
                      class: {
                        "text-success": _vm.imported && _vm.count,
                        "text-danger": _vm.imported && !_vm.count,
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$tc("imported_vehicles", _vm.count, {
                              vehicles: _vm.count,
                            })
                          ) +
                          " "
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          : _vm._e(),
        _c(
          "div",
          { staticClass: "row imports" },
          [
            _vm.device == "desktop"
              ? [
                  _c(
                    "div",
                    {
                      staticClass: "col action-button",
                      class: {
                        "pr-1": _vm.vehicles && _vm.vehicles.length,
                        "pr-3": !(_vm.vehicles && _vm.vehicles.length),
                      },
                    },
                    [
                      _c("input", {
                        ref: "file",
                        staticClass: "d-none",
                        attrs: { type: "file" },
                        on: {
                          change: function ($event) {
                            return _vm.importVehiclesCSV()
                          },
                        },
                      }),
                      _c(
                        "button",
                        {
                          staticClass: "d-block main-btn w-100",
                          on: {
                            click: function ($event) {
                              return _vm.$refs.file.click()
                            },
                          },
                        },
                        [
                          _c("span", {
                            staticClass: "fas fa-long-arrow-alt-up",
                          }),
                          _vm._v(" " + _vm._s(_vm.$t("btn_import_csv")) + " "),
                        ]
                      ),
                    ]
                  ),
                  _vm.vehicles && _vm.vehicles.length
                    ? _c("div", { staticClass: "col action-button pr-md-1" }, [
                        _c(
                          "button",
                          {
                            staticClass: "d-block main-btn w-100",
                            on: {
                              click: function ($event) {
                                return _vm.exportVehiclesCSV()
                              },
                            },
                          },
                          [
                            _c("span", {
                              staticClass: "fas fa-long-arrow-alt-down",
                            }),
                            _vm._v(
                              " " + _vm._s(_vm.$t("btn_export_csv")) + " "
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ]
              : _vm._e(),
            _vm.vehicles && _vm.vehicles.length
              ? _c(
                  "div",
                  { staticClass: "col-12 col-sm-12 col-md action-button" },
                  [
                    _c("router-link", { attrs: { to: { name: "add-car" } } }, [
                      _c(
                        "button",
                        {
                          staticClass: "main-btn w-100 mt-3 mt-md-0",
                          attrs: { type: "submit" },
                        },
                        [
                          _vm._v(" " + _vm._s(_vm.$t("btn_add_car")) + " "),
                          _c("i", { staticClass: "fas fa-plus mr-2" }),
                        ]
                      ),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
          ],
          2
        ),
        [
          _c("div", { staticClass: "d-sm-flex" }, [
            _c("div", { staticClass: "d-flex search-car-number-wrapper" }, [
              _c("div", { staticClass: "form-group search-car-number" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.carPlateFilter,
                      expression: "carPlateFilter",
                    },
                  ],
                  staticClass: "form-control mb-3",
                  attrs: {
                    type: "text",
                    placeholder: _vm.$t("search_car_after_license_plate"),
                  },
                  domProps: { value: _vm.carPlateFilter },
                  on: {
                    keypress: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.loadVehicles.apply(null, arguments)
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.carPlateFilter = $event.target.value
                    },
                  },
                }),
              ]),
              _c(
                "button",
                {
                  staticClass: "main-btn",
                  on: {
                    click: function ($event) {
                      return _vm.loadVehicles()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("search_car_button")))]
              ),
            ]),
            _c(
              "div",
              { staticClass: "form-group pl-sm-3 mb-3 flex-sm-grow-1" },
              [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.sortBy,
                        expression: "sortBy",
                      },
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.sortBy = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c("option", { domProps: { value: null } }, [
                      _vm._v(_vm._s(_vm.$t("sort_by")) + ":"),
                    ]),
                    _c("option", { domProps: { value: "vignette_expiry" } }, [
                      _vm._v(_vm._s(_vm.$t("sort_vignette_expiry"))),
                    ]),
                    _c("option", { domProps: { value: "car_plate_asc" } }, [
                      _vm._v(_vm._s(_vm.$t("sort_by_car_name"))),
                    ]),
                  ]
                ),
              ]
            ),
            _c(
              "div",
              { staticClass: "form-group pl-sm-3 mb-3 flex-sm-grow-1" },
              [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.filterByVignetteStatus,
                        expression: "filterByVignetteStatus",
                      },
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.filterByVignetteStatus = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c("option", { domProps: { value: null } }, [
                      _vm._v(_vm._s(_vm.$t("show_all_vehicles"))),
                    ]),
                    _c("option", { domProps: { value: "active" } }, [
                      _vm._v(
                        _vm._s(_vm.$t("show_only_active_vignette_vehicles"))
                      ),
                    ]),
                    _c("option", { domProps: { value: "expired" } }, [
                      _vm._v(
                        _vm._s(_vm.$t("show_only_expired_vignette_vehicles"))
                      ),
                    ]),
                  ]
                ),
              ]
            ),
          ]),
          _vm._l(_vm.vehicles, function (item, key) {
            return _vm.vehicles && _vm.vehicles.length
              ? _c(
                  "div",
                  { key: "vehicle-" + key, staticClass: "cart-item remove-a" },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-md-flex d-block mb-2 w-100 justify-content-between align-items-center",
                          },
                          [
                            _c("p", { staticClass: "fs-big" }, [
                              _vm._v(_vm._s(item._plateNo)),
                            ]),
                            _c("p", { staticClass: "fs-medium" }, [
                              _vm._v(_vm._s(item.country.country)),
                            ]),
                          ]
                        ),
                        item._chasisNo
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "d-md-flex d-block mb-2 w-100 justify-content-between align-items-center",
                              },
                              [
                                _c("div", { staticClass: "fs-size" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.capitalize(
                                        _vm.$t("label_chasis_number")
                                      )
                                    )
                                  ),
                                ]),
                                _c("div", { staticClass: "fs-medium" }, [
                                  _vm._v(_vm._s(item._chasisNo)),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        item.category_vignette
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "d-md-flex d-block mb-2 w-100 justify-content-between align-items-center",
                              },
                              [
                                _c("div", { staticClass: "fs-size" }, [
                                  _vm._v(
                                    _vm._s(_vm.capitalize(_vm.$t("category"))) +
                                      " " +
                                      _vm._s(_vm.$tc("vignetteWord", 1))
                                  ),
                                ]),
                                _c("div", { staticClass: "fs-medium" }, [
                                  _vm._v(
                                    _vm._s(
                                      item.category_vignette.title.replace(
                                        "Categoria",
                                        ""
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        item.category_toll
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "d-md-flex d-block mb-2 w-100 justify-content-between align-items-center",
                              },
                              [
                                _c("div", { staticClass: "fs-size" }, [
                                  _vm._v(
                                    _vm._s(_vm.capitalize(_vm.$t("category"))) +
                                      " " +
                                      _vm._s(_vm.$tc("tollWord", 1))
                                  ),
                                ]),
                                _c("div", { staticClass: "fs-medium" }, [
                                  _vm._v(
                                    _vm._s(
                                      item.category_toll.title.replace(
                                        "Categoria",
                                        ""
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-md-flex d-block mb-2 w-100 justify-content-between align-items-center",
                          },
                          [
                            _c("div", { staticClass: "fs-size" }, [
                              _vm._v(_vm._s(_vm.$t("vignette_status"))),
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "fs-medium",
                                class: {
                                  "text-success":
                                    item.vignette_active_status_count,
                                  "text-danger":
                                    !item.vignette_active_status_count &&
                                    item.vignette_all_time_status_count,
                                },
                              },
                              [_vm._v(_vm._s(_vm.vignetteStatus(item)))]
                            ),
                          ]
                        ),
                        _c("div", { staticClass: "action-buttons" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-block d-md-flex justify-content-between align-items-center",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-md-flex justify-content-between",
                                },
                                [
                                  item.category_vignette
                                    ? _c(
                                        "div",
                                        { staticClass: "mr-md-4 mb-3" },
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              staticClass: "btn main-btn",
                                              attrs: {
                                                to: {
                                                  name: "vignette-category",
                                                  params: {
                                                    id: item.category_vignette
                                                      .id,
                                                    carId: item.id,
                                                  },
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fas fa-cart-plus",
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("vignette_buy")
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "div",
                                        { staticClass: "mr-md-4 mb-3" },
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              staticClass:
                                                "btn main-btn warning d-flex justify-content-center align-items-center",
                                              attrs: {
                                                to: {
                                                  name: "edit-car",
                                                  params: { id: item.id },
                                                },
                                              },
                                            },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "far fa-pencil-alt mr-2",
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "fill_in_erv_category"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                  item._category_TPF
                                    ? _c(
                                        "div",
                                        { staticClass: "mr-md-4 mb-3" },
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              staticClass: "btn main-btn",
                                              attrs: {
                                                to: {
                                                  name: "toll-category",
                                                  params: {
                                                    id: item._category_TPF,
                                                    carId: item.id,
                                                  },
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fas fa-cart-plus",
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.$t("toll_buy")) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "div",
                                        { staticClass: "mr-md-4 mb-3" },
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              staticClass:
                                                "btn main-btn warning d-flex justify-content-center align-items-center",
                                              attrs: {
                                                to: {
                                                  name: "edit-car",
                                                  params: { id: item.id },
                                                },
                                              },
                                            },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "far fa-pencil-alt mr-2",
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "fill_in_tpf_category"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                  _c("div", [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "btn main-btn d-flex justify-content-center align-items-center",
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.brokerNetService.goToBrokerNet()
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("insurance_buy")) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-start justify-sm-content-end align-items-center mt-sm-4 mt-2",
                                },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "edit-btn",
                                      attrs: {
                                        to: {
                                          name: "edit-car",
                                          params: { id: item.id },
                                        },
                                      },
                                    },
                                    [_c("span", { staticClass: "edit-icon" })]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "trash-btn",
                                      on: {
                                        click: function ($event) {
                                          return _vm.remove(item.id)
                                        },
                                      },
                                    },
                                    [_c("span", { staticClass: "delete-icon" })]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                )
              : _vm._e()
          }),
        ],
        _c("Pagination", {
          attrs: { page: _vm.page, total: _vm.vehicles_total },
          on: { goToPage: _vm.setPage },
        }),
        _c(
          "div",
          { staticClass: "action-button text-center bottom-action-btn" },
          [
            _c("router-link", { attrs: { to: { name: "add-car" } } }, [
              _c(
                "button",
                { staticClass: "main-btn", attrs: { type: "submit" } },
                [
                  _vm._v(" " + _vm._s(_vm.$t("btn_add_car")) + " "),
                  _c("i", { staticClass: "fas fa-plus mr-2" }),
                ]
              ),
            ]),
          ],
          1
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "mb-0" }, [
      _vm._v(
        " Folosiți această pagină pentru a încarcă informațiile vehiculelor dvs. in cont."
      ),
      _c("br"),
      _c("a", { attrs: { href: "/media/exemple.csv" } }, [
        _vm._v("Apasați aici"),
      ]),
      _vm._v(" pentru a descărca fișierul model sau "),
      _c("a", { attrs: { href: "/media/coduri_tari.rar" } }, [
        _vm._v("apasați aici"),
      ]),
      _vm._v(" pentru a descarcă pdf-ul pentru codurile țări."),
      _c("br"),
      _vm._v(
        " Pentru a reuși importul, fișierul trebuie să respecte următoarele reguli: "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", [
      _c("li", [_vm._v("Să fie fișier salvat în formatul csv (.csv)")]),
      _c("li", [
        _vm._v(" Să conțină 5 coloane: "),
        _c("ul", [
          _c("li", [
            _vm._v(
              "Numărul de înmatriculare (fără spații sau alte caractere, ex: AG01DAB)"
            ),
          ]),
          _c("li", [_vm._v("Seria de șasiu")]),
          _c("li", [_vm._v("Categorie rovinietă")]),
          _c("li", [_vm._v("Categorie taxă pod fetești")]),
          _c("li", [_vm._v("Cod tară")]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }